module.exports = __webpack_public_path__ + "img/avatar-620.785114cd.png";